"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _spacing = _interopRequireDefault(require("@decisiv/design-tokens/lib/spacing"));

var _intents = require("./intents");

var _Flex = _interopRequireDefault(require("../Flex"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @ts-ignore
var Container = (0, _styledComponents.default)(_Flex.default).withConfig({
  displayName: "Container",
  componentId: "egscd9-0"
})(["border-left-style:solid;border-left-width:", ";border-radius:", ";text-align:left;& > svg{margin-top:", ";height:", ";width:", ";}", ""], (0, _rem.default)(_spacing.default.base * 0.2), (0, _rem.default)(_spacing.default.base * 0.2), (0, _rem.default)(_spacing.default.base * 0.1), (0, _rem.default)(_spacing.default.base * 1.6), (0, _rem.default)(_spacing.default.base * 1.6), _intents.intentStyle);
var _default = Container;
exports.default = _default;